import { textToKebab } from './toKebabCase'
import qs from 'qs'

const topicUrlGenerator = (type: string, title: string, id: string, category?: string | null, postId?: string) => {
  const typePath = `/${type}`
  const categoryPath = category ? `/${category}` : ''
  const titlePath = `/${textToKebab(title)}`
  const idPath = `-${id}`
  const postIdPath = postId ? `?postid=${postId}#post${postId}` : ''
  return (typePath + categoryPath + titlePath + idPath + postIdPath).toLowerCase()
}

export const generateNewUrl = (newPage: number) => {
  const regex = /\/index\d+\.html/
  const splittedUrl = window.location.pathname.replace(regex, '')
  const newPagination = newPage === 1 ? '' : `/index${newPage}.html`
  const searchQuery = window.location.search
  const queryParameters = qs.parse(searchQuery, { ignoreQueryPrefix: true })
  delete queryParameters?.postid
  return `${window.location.origin}${splittedUrl}${newPagination}${qs.stringify(queryParameters) as string}`
}

export default topicUrlGenerator
